import { render, staticRenderFns } from "./retur-header.vue?vue&type=template&id=6a617714&"
import script from "./retur-header.vue?vue&type=script&lang=js&"
export * from "./retur-header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports